export default "__VITE_ASSET__DHRLc9rE__"